import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import workSpaceCss from "../../css/workSpaceOverView.module.css";
import PopulateFSSideMenu from "../../components/consol/PopulateFSSideMenu";
import PopulateFSTopBar from "../../components/consol/PopulateFSTopBar";

import swal from "sweetalert";
import {
  deletePopulateFSApiHandler,
  getConsolPopulateFSDetailsApiHandler,
  updatePopulateFSApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import QuillReactEditor from "../../components/QuillReactEditor";
import ConsolFSTable from "./ConsolFSTable";
import sidemenucss from "../../css/sidemenu.module.css";
const ConsolFS = () => {
   const {consolID} = useParams();
   const location = useLocation();

   const subTitle = location.state?.consolName || "";

  //const consolID = "6953a4b5d73b643b49e70826";

  const history = useHistory();
  const dispatch = useDispatch();

  const [activeCat, setActiveCat] = useState("BS");
  const [isNotes, setIsNotes] = useState(false);
  const [loadData, setLoadData] = useState([]);
  const [notesId, setNotesId] = useState(null);
  const [redirectNote, setRedirectNote] = useState(null);
  const [subMenuId, setSubMenuId] = useState(null);
  const [subgroupId, setSubGroupId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [subMenu, setSubMenu] = useState(null);
  const [rows, setRows] = useState([]);
  const [notesData, setNotesData] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(0);

  useEffect(() => {
    if ((activeCat === "BS") || (activeCat === "PL")) {
      const result = transformData(loadData ?? []);
      setRows(result ?? []);
    } else {

      setRows(loadData ?? []);
    }
  }, [loadData]);


  useEffect(() => {
    setColumns([]);

    // BS / PL
    if (activeCat === "BS" || activeCat === "PL") {
      setIsNotes(false);
      setSubMenu(null);
      setColumns([
        {
          label: "Particular",
          field: "particular",
          align: "left",
          editable: false,
          width: "45%",        
          cellStyle: () => ({
            whiteSpace: "normal", 
            wordBreak: "break-word",
            lineHeight: "1.4",
          }),
          headerStyle: {
            width: "45%",         
            whiteSpace: "normal",
          },
        },
        {
          label: "Notes",
          field: "notes",
          align: "center",
          editable: false,
          type: "redirect",
          width: "10%",
          headerStyle: { width: "10%" },
        },
        {
          label: "Current Year",
          field: "currentYear",
          align: "right",
          editable: false,
          type: "number",
          width: 160,
          minWidth: 160,
          maxWidth: 160,

        },
        {
          label: "Previous Year",
          field: "previousYear",
          align: "right",
          editable: false,
          type: "number",
          width: 180,
          minWidth: 180,
          maxWidth: 180,

        },
        // {
        //   label: "References",
        //   field: "references",
        //   align: "left",
        //   editable: false,
        //   type: "array",
        // },
      ]);
      return;
    }

    // SOCIE / Cashflow / Disclosure
    if (["socie", "cashflow", "disclosure"].includes(activeCat)) {
      setIsNotes(false);
      setSubMenu(null);

      if (rows.length > 0) {
        const catRows = Object.keys(rows[0] || {});
        const tableCols = catRows
          .filter(
            (item) =>
              item !== "_id" && item !== "lineType" && item !== "references"
          )
          .map((item) => ({
            label: item,
            field: item,
            align: "left",
            editable: false,
            type: "text",
          }));

        setColumns(tableCols);
      }
      return;
    }

    // Notes categories
    if (
      ["general notes", "BS notes", "PL notes","disclosure", "checklist"].includes(activeCat)
    ) {
      setIsNotes(true);
      const submenuArray = rows.map((item) => ({
        label: item.particular,
        value: item._id,
        subGroup: item.subgroup, 
      }));
      setSubMenu({
        category: activeCat,
        submenu: submenuArray,
      });
      setColumns([]);
      return;
    }

    // Default
    setIsNotes(false);
    setSubMenu(null);
    setColumns([]);
  }, [activeCat, rows]);

  useEffect(() => {
    if (!isNotes) return;
    if (!subMenu?.submenu?.length) return;

    if (subMenuId) return;

    const first = subMenu.submenu[0];
    setSubMenuId(first.value);
  }, [isNotes, activeCat, subMenu, subMenuId]);

  const handleRowsChange = (updatedRows) => {
    // console.log("updatedRows", updatedRows);
    // If you want local update from ConsolFSTable:
    // setRows(updatedRows);
  };

  const menuItems = [
    { label: "Balance Sheet", value: "BS" },
    { label: "P&L Statement", value: "PL" },
    { label: "General Notes", value: "general notes" },
    { label: "CashFlow", value: "cashflow" },
    { label: "SOCIE", value: "socie" },
    { label: "Balance Sheet Notes", value: "BS notes" },
    { label: "P&L Statement Notes", value: "PL notes" },
    { label: "Disclosures", value: "disclosure" },
    { label: "Disclosures Checklist", value: "checklist" },
  ];

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    getConsolPopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          setLoadData(catData);
        }
        else {
          setLoadData([]);
          swal(
            "Error",
            response?.data?.error || "Unable to get FS the data",
            "error"
          );
        }
      })
      .catch((error) => {
        setLoadData([]);
        swal(
          "Error",
          error?.response?.data?.error || "Unable to Populate FS the data",
          "error"
        );
      });
  };

  // When category changes, reset and fetch
  useEffect(() => {
    setColumns([]);
    setSubMenu(null);
    setIsNotes(false);
    setNotesData(null);
    setSubGroupId(null);
    setSubMenuId(null);
    getPopulateFS(activeCat);
  }, [activeCat]);

  const debounceTimer = useRef(null);

  const handleTableEdit = ({ _id, key, value, type = "table", tableId }) => {
    const params = {
      category: activeCat,
      consolID: consolID,
    };

    if (isNotes && type !== "text") {
      params["groupID"] = subMenuId;
      if (activeCat === "checklist") {
        params["subgroupID"] = _id;
      } else {
        params["subgroupID"] = tableId;
        params["rowID"] = _id;
      }
    } else {
      if (
        activeCat === "BS" ||
        activeCat === "PL" ||
        activeCat === "socie" ||
        activeCat === "cashflow" ||
        activeCat === "disclosure"
      ) {
        params["groupID"] = _id;
      }
    }

    const payload = {};

    if (isNotes && type === "text") {
      params["groupID"] = subMenuId;
      params["subgroupID"] = _id;

      payload["textRaw"] = key; // html
      payload["textPlain"] = value; // plaintext
    } else {
      payload[key] = value;
    }

    console.log("update params,payload", params, payload);

    updatePopulateFSApiHandler(params, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          if (isNotes) {
            if (type === "text") {
              // Update text subgroup in rows
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== _id) return sg;
                        return {
                          ...sg,
                          textRaw: payload.textRaw,
                          textPlain: payload.textPlain,
                        };
                      }
                    ),
                  };
                })
              );
            } else {
              // Update table row inside subgroup
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== subgroupId) return sg;
                        return {
                          ...sg,
                          table: (sg.table || []).map((row) =>
                            row._id === _id ? { ...row, [key]: value } : row
                          ),
                        };
                      }
                    ),
                  };
                })
              );
            }
          } else {
            // Non-notes tables (BS, PL, etc.)
            setRows((prev) =>
              prev.map((row) =>
                row._id === _id ? { ...row, [key]: value } : row
              )
            );
          }
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update the data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to save the data",
          "error"
        );
      });
  };

  const handleTableEditDebounced = (args) => {
    clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      handleTableEdit(args);
    }, 2000);
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimer.current); 
  }, []);

  const ShowDetails = () => {

    return (
      <>
        <ConsolFSTable
          columns={columns}
          rows={rows}
          onRowsChange={handleRowsChange}
          onCellChangeImmediate={handleTableEditDebounced}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const ShowChecklist = ({ subMenuId }) => {
    if (!subMenu) return null;

    const selNote = subMenu.submenu.find((item) => item.value === subMenuId);
    const rows = selNote?.subGroup || [];

    const checklistColumns = [
      {
        label: "Paragraph reference",
        field: "reference",
        align: "left",
        editable: false,
        type: "popup",
      },
      {
        label: "Disclosure",
        field: "notes",
        align: "left",
        maxWidth: 200,
        editable: false,
        type: "text",
      },
      {
        label: "Yes",
        field: "value",
        optionValue: "Y",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "No",
        field: "value",
        optionValue: "N",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "NA",
        field: "value",
        optionValue: "NA",
        align: "center",
        editable: false,
        type: "checkbox",
      },
      {
        label: "Remarks",
        field: "remark",
        align: "left",
        editable: false,
        type: "text",
      },
    ];

    return (
      <>
        <ConsolFSTable
          columns={checklistColumns}
          rows={rows}
          onRowsChange={handleRowsChange}
          onCellChangeImmediate={handleTableEditDebounced}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const getPopulateFSNotes = async (cat) => {
    try {
      const getParams = {
        category: cat,
        consolID: consolID,
      };

      const response = await getConsolPopulateFSDetailsApiHandler(getParams);

      if (response?.data?.success === true) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const redirectTo = async (arg) => {
    let subNotesCat = null;

    if (activeCat === "BS") {
      setActiveCat("BS notes");
      subNotesCat = "BS notes";
    }
    if (activeCat === "PL") {
      setActiveCat("PL notes");
      subNotesCat = "PL notes";
    }

    if (subNotesCat) {
      const data = await getPopulateFSNotes(subNotesCat);
      const resultId = data.find((item) => item.notes === arg)?._id;
      setRedirectNote(resultId || null);
    }
  };

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = rows.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);
  }, [isNotes, activeCat, subMenuId, rows]);

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !notesData) return;

    const subGroups = notesData.subgroup || notesData.subGroup || [];
    const firstTableSg = subGroups.find(
      (sg) => (sg?.dataType ?? sg?.datatype) === "table"
    );

    setSubGroupId(firstTableSg?._id ?? null);
  }, [isNotes, activeCat, notesData]);

  const showNotesDetails = (noteId) => {
    setSubMenuId(noteId);
  };

  const deletePopulateFS = async (subgroupID) => {
    try {
      const getParams = {
        category: activeCat,
        consolID: consolID,
        groupID: subMenuId,
        subgroupID: subgroupID
      };

      const response = await deletePopulateFSApiHandler(getParams);

      console.log("response", response);
      setUpdateTrigger((prev) => prev + 1);
      const delEl = document.getElementById(subgroupID)
      if (delEl) delEl.style.display = "none"
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = rows.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);

  }, [updateTrigger]);

  const renderSubGroups = (notesData) => {
    const subGroups = notesData?.subgroup || notesData?.subGroup || [];

    return subGroups.map((sg, idx) => {
      const type = sg?.dataType ?? sg?.datatype ?? "";

      //  TABLE 
      if (type === "table") {
        const tableItems = Array.isArray(sg.table) ? sg.table : [];

        if (tableItems.length === 0) {
          return (
            <div key={`table-empty-${idx}`} className="mb-4">
              <small>No table data available</small>
            </div>
          );
        }

      //   const catRows = Object.keys(tableItems[0] || {});
      //   // const tableCols = catRows
      //   //   .filter((col) => col !== "_id")
      //   //   .map((col) => {
      //   //     if (col === "references") {
      //   //       return {
      //   //         label: col,
      //   //         field: col,
      //   //         align: "left",
      //   //         editable: false,
      //   //         type: "checklistref",
      //   //       };
      //   //     }
      //   //     return {
      //   //       label: col,
      //   //       field: col,
      //   //       align: "left",
      //   //       editable: false,
      //   //       type: "text",
      //   //     };
      //   //   });
      //   const normalCols = catRows.filter(
      //     (col) => col !== "_id" && col !== "references"
      //   );

      //  const isNotesYearAlign =
      //   activeCat === "BS notes" || activeCat === "PL notes";

      // const tableCols = [
      //   ...normalCols.map((col) => ({
      //     label: col,
      //     field: col,

      //     align:
      //       isNotesYearAlign &&
      //       (col.toLowerCase().includes("current") ||
      //         col.toLowerCase().includes("previous"))
      //         ? "right"
      //         : "left",

      //     editable: false,
      //     type: "text",
      //   })),


          
      //     ...(catRows.includes("references")
      //       ? [
      //           {
      //             label: "references",
      //             field: "references",
      //             align: "left",
      //             editable: false,
      //             type: "checklistref",
      //           },
      //         ]
      //       : []),
      //   ];

      const catRows = Object.keys(tableItems[0] || {});

const normalCols = catRows.filter(
  (col) => col !== "_id" && col !== "references"
);


const isNotesYearAlign =
  activeCat === "BS notes" || activeCat === "PL notes";

const hideReferences =
  activeCat === "BS notes" || activeCat === "PL notes";

 const yearWidth = 200;
const tableCols = [
  ...normalCols.map((col) => {
    const isCurrent = col.toLowerCase().includes("current");
    const isPrevious = col.toLowerCase().includes("previous");

    return {
      label: col,
      field: col,
      align:
        isNotesYearAlign && (isCurrent || isPrevious)
          ? "right"
          : "left",
      editable: false,
      type: "text",

        width: isNotesYearAlign && (isCurrent || isPrevious) ? yearWidth : undefined,
        minWidth: isNotesYearAlign && (isCurrent || isPrevious) ? yearWidth : undefined,
        maxWidth: isNotesYearAlign && (isCurrent || isPrevious) ? yearWidth : undefined,


      headerStyle:
        isNotesYearAlign && (isCurrent || isPrevious)
          ? { width: "200px" }
          : {},

    };
  }),

  ...(catRows.includes("references") && !hideReferences
    ? [
        {
          label: "references",
          field: "references",
          align: "left",
          editable: false,
          type: "checklistref",
        },
      ]
    : []),
];



        return (
          <React.Fragment key={`table-${idx}`}>
            <ConsolFSTable
              columns={tableCols}
              rows={tableItems}
              onRowsChange={handleRowsChange}
              onCellChangeImmediate={handleTableEditDebounced}
              redirectTo={redirectTo}
              tableTitle={sg?.tableTitle}
              tableId={sg?._id}
              tableType={sg?.tableType}
              deletePopulateFS={deletePopulateFS}
            />
          </React.Fragment>
        );
      }

      //  TEXT 
      if (type === "text") {
        return (
          <div className="mt-5" key={`text-${idx}`}>
            <QuillReactEditor
              value={sg?.textRaw ?? ""}
              onChange={(content) => {
                handleTableEdit({
                  _id: sg?._id,
                  key: content.html,
                  value: content.text,
                  type: "text",
                });
              }}
            />
          </div>
        );
      }

      //  FALLBACK 
      return <div key={`empty-${idx}`} />;
    });
  };

  const transformData = (data) => {
    const output = [];

    const walk = (node) => {
      if (node.level === 3) return;
      const type = node.level === 1 ? "header" : "row";

      output.push({
        _id: node._id,
        lineType: type,
        particular: node.name,
        notes: node.notes ?? null,
        currentYear: node.currentYear ?? null,
        previousYear: node.previousYear ?? null,
        references: node.references ?? []
      });

      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
    };

    data.forEach(walk);
    return output;
  };

  return (
    <>
      <div className={`${workSpaceCss.df}`}>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <PopulateFSSideMenu
              title="Consol Financial Statements"
              titleClassName={sidemenucss.customTitle}
              subTitle={subTitle}
              menuItems={menuItems}
              subMenu={subMenu}
              activeCat={activeCat}
              setActiveCat={setActiveCat}
              setSubMenuId={setSubMenuId}
              showNotesDetails={showNotesDetails}
              redirectNote={redirectNote}
              setRedirectNote={setRedirectNote}
              subMenuId={subMenuId}
            />
          </motion.div>
          <div
            className={bookclosurecss.bookClosureContent}
            style={{ width: "85vw" }}
          >
            <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
              <PopulateFSTopBar history={history} consolID={consolID} />
            </div>
            <div
              style={{
                height: "88vh",
                overflow: "auto",
                padding: "0px 20px",
              }}
            >
              {!isNotes && activeCat !== "checklist" && <ShowDetails />}

              {isNotes && notesData && activeCat !== "checklist" && (
                <>
                  {renderSubGroups(notesData)}
                </>
              )}

              {isNotes && subMenuId && activeCat === "checklist" && (
                <ShowChecklist subMenuId={subMenuId} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsolFS;
